export default "__VITE_ASSET__50469b09__"